const appBar = {
  backgroundColor: 'white',
  maxHeight: '4.25rem',
  maxWidth: '100%',
  width: '100%',
};

const toolbar = {
  display: 'flex',
  justifyContent: 'space-between',
  padding: { xs: '0.25rem 1rem', phone: '0.25rem 2rem' },
  backgroundColor: 'white',
  width: '100%',
};

const headerStack = {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'flex-start',
  justifyContent: { xs: 'space-between', phone: 'center' },
  width: '100%',
  position: 'relative',
};

const logoStyles = {
  position: 'absolute',
  left: '50%',
  width: { xs: '50px', phone: '110px' },
};

const menuButton = {
  position: 'absolute',
  right: '0',
  top: '50%',
  transform: 'translateY(-50%)',
};

const drawerStyles = {
  width: '100%',
  '& .MuiPaper-root': {
    width: '100%',
    height: '100%',
    marginTop: '3.5rem',
    boxShadow: 'none',
    position: 'relative',
    flexShrink: 0,
    overflowY: 'auto',
  },
  '& .MuiBackdrop-root': {
    backgroundColor: 'transparent',
  },
  '& .MuiSlide-root': {
    transition: 'all 1s ease-in-out',
  },
};

const drawerContentStack = {
  gap: '2rem',
  padding: '2rem',
  marginBottom: '5rem',
};

const mobileNavbarButton = (theme) => ({
  marginLeft: '1rem',
  padding: '0.5rem 1rem',
  border: `2px solid ${theme.palette.primary.main}`,
});

export {
  appBar,
  toolbar,
  headerStack,
  logoStyles,
  menuButton,
  drawerStyles,
  drawerContentStack,
  mobileNavbarButton,
};
